import { Col, Row } from 'antd';
import { DndContext, KeyboardSensor, PointerSensor, closestCenter, useSensor, useSensors } from '@dnd-kit/core';
import {
  SortableContext,
  arrayMove,
  horizontalListSortingStrategy,
  sortableKeyboardCoordinates,
} from '@dnd-kit/sortable';

import DraggerItems from './dragger-items';
import DraggerZone from './dragger-zone';
import { findIndex } from 'lodash';

export default function DraggerSortableContainer({
  fileList = [],
  loading = false,
  onSortableEnd = undefined,
  onUploadChange = undefined,
  onRemove = undefined,
  maxLength = 5,
}) {
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8,
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (active.id !== over.id) {
      const oldIndex = findIndex(fileList, (ss) => ss.uid === active.id);
      const newIndex = findIndex(fileList, (ss) => ss.uid === over.id);
      const newFileList = arrayMove(fileList, oldIndex, newIndex);

      onSortableEnd?.(newFileList);
    }
  };

  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
      <SortableContext items={fileList} strategy={horizontalListSortingStrategy}>
        <Row style={{ flexDirection: 'row', marginLeft: -15 }}>
          {fileList.map((items, index) => (
            <Col key={index} xs={4}>
              <DraggerItems items={items} onRemove={() => onRemove(items.uid)} />
            </Col>
          ))}

          <Col xs={4} style={{ display: fileList.length < maxLength ? 'initial' : 'none' }}>
            <DraggerZone loading={loading} fileList={fileList} onChange={onUploadChange} />
          </Col>
        </Row>
      </SortableContext>
    </DndContext>
  );
}
